<h2>Organization Admin</h2>
<app-basic-action-table
  dataName="Organization"
  [columns]="columns"
  [actions]="actions"
  [filterComparator]="filterComparator"
  endpoint="organization"
  (actionEvent)="eventDetected($event)"
></app-basic-action-table>
